/**
 * Component member-item-default JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */
 
jQuery(document).ready(function () {
    const component = jQuery('.member-item-default');
    
    if (!component.length) {
        return;
    }

    jQuery('.ll-modal-trigger', component).bind('click', function (e) {
        const modalAnchor = '#' + jQuery(this).data('anchor');
        jQuery('.member-item-default__modal').removeClass('modal-open');
        jQuery('body, ' + modalAnchor).addClass('modal-open');
    });

    jQuery('a.ll-close-modal', component).bind('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        jQuery('body, .member-item-default__modal').removeClass('modal-open');
    });




});